import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { GlobalTranslationsQueryDocument } from '@docpace/manager-graphql/dist/urql.types'
import { GlobalTranslationsQueryResultFragment } from '@docpace/manager-graphql'

const typedGlobalTranslationsQueryDocument = GlobalTranslationsQueryDocument as TypedDocumentNode<GlobalTranslationsQueryResultFragment>

export function useGlobalTranslationsQuery(opts?: useQuery.Options<GlobalTranslationsQueryResultFragment>){
    return useQuery(typedGlobalTranslationsQueryDocument, opts)
}
